
import Efct21 from '../../../acets/efectsfilters/21.png'
import { useFont } from '../../../ContextFont';
import Advogado from'../../../acets/adv.jpg'
import IcoEdit from'../../../acets/icon/edit.svg'
import { useEffect, useState } from 'react';
export default function Lay15(props){
  const { fonte, alterarFonte, imagens, adicionarImagem, handleDownloadImage } = useFont();
  const [titulo, setTitulo]=useState(props.datal.titulo)
  const [subtitulo,setSubtitulo]=useState(props.datal.subtitulo)
  const [modalData, setModaldata]=useState(false)
  const [numimg,setNumimg]=useState(3)
  
  useEffect(() => {
    // Atualiza os estados locais quando props.datal é alterado
    setTitulo(props.datal.titulo);
    setSubtitulo(props.datal.subtitulo);
  }, [props.datal]); 
  return(
      <div className='w33 cell-tamanho90 center celular  b2 cont-circ7 bordaElements ma10b0'>
      <div className='p10 b2 w10 cont-circ50pc fb'>15</div>
      <div id="resultImg15"className="w100 h40 column between cell-tamanho " >
        
        <div className='w100 h40 column end' style={{ background: props.trapColor }}>
        <div className='w100 h40 column center cell-tamanho' style={{ backgroundImage: `url(${Efct21})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',backgroundPosition:'center' }}>
          <label className='c3 fb p14' style={{fontSize:`${props.titlesize}px`,color:props.textColor}}>{props.datal.titulo}</label>
          <label className='p7 fw500 z4 cen' style={{ fontSize: `${props.subtitlesize}px`, color: props.subtextColor }}>{props.datal.subtitulo}</label>
        </div>
      </div>
      { modalData&&
            <div className='posiabste b2 h30 z16 w17 p10 cell-tamanho-metade55 bordaElements'>
              <div className='w100 row between'>
                 <label className=''>Titulo</label>
                <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' className='pp w10' onClick={() => setModaldata(!modalData)}/>
              </div>
              <input type='text' value={titulo} onChange={(e)=>setTitulo(e.target.value)}/>
              <label>Subtitulo</label>
              <input type='text' value={subtitulo} onChange={(e)=>setSubtitulo(e.target.value)}/>
            </div>
            }
      </div>
      <div className="w100 he20 overflowY">
          <div className="w100 row between ma5">
            <div className="row w50">
            <img src='https://cdn-icons-png.flaticon.com/128/535/535285.png' className='w15 ml5' alt='plus / mais'/>
            <img src='https://cdn-icons-png.flaticon.com/128/5948/5948565.png' className='w15 ml5' alt='plus / mais'/>
            <img src='https://cdn-icons-png.flaticon.com/128/5728/5728145.png' className='w15 ml5' alt='plus / mais'/>
            </div>
            <div className="w50 row between">
            
            </div>
          </div>
          <label className="fs08em">{props.datal.legenda}</label>
          <div>
            <label className="w100 fs08em fw500">{props.datal.hashtag}</label>
          </div>
        </div>
        <div className='w100 row between'> 
        <div className='h5 w30 fs08em cont-circ8 pp b2 row center  m10' 
            onClick={() => setNumimg(numimg >= 9 ? 0 : numimg + 1)}>
              Imagem
              <img src='https://cdn-icons-png.flaticon.com/128/1829/1829415.png' alt='IcoEdit' className='w17 m10'/>
            </div>
        <div 
            className='w30 h5 fs08em cont-circ8 pp b2 row center  m10'
            onClick={() => setModaldata(!modalData)}>
            {modalData ? "Fech." : "Texto"}
            <img src={IcoEdit} alt='IcoEdit' className='w25'/>
        </div>
        <div 
          className="w30 h5 fs08em cont-circ8 pp b2 row center  m10" 
          onClick={() => handleDownloadImage('resultImg15')}>
            Baixar
          <img src='https://cdn-icons-png.flaticon.com/128/5191/5191992.png' alt='IcoEdit' className='w17 m10'/>
        </div>
      </div> 
      </div>
    )
}